export interface TranslationLanguage {
  code: string;
  name: string;
  flag: string;
  native: string;
}

// 99+ languages supported by OpenAI for translation
export const TRANSLATION_LANGUAGES: TranslationLanguage[] = [
  // Major World Languages
  { code: 'en', name: 'English', flag: '🇬🇧', native: 'English' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸', native: 'Español' },
  { code: 'fr', name: 'French', flag: '🇫🇷', native: 'Français' },
  { code: 'de', name: 'German', flag: '🇩🇪', native: 'Deutsch' },
  { code: 'it', name: 'Italian', flag: '🇮🇹', native: 'Italiano' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹', native: 'Português' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', flag: '🇧🇷', native: 'Português (Brasil)' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺', native: 'Русский' },
  { code: 'zh', name: 'Chinese (Simplified)', flag: '🇨🇳', native: '简体中文' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', flag: '🇹🇼', native: '繁體中文' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵', native: '日本語' },
  { code: 'ko', name: 'Korean', flag: '🇰🇷', native: '한국어' },
  { code: 'ar', name: 'Arabic', flag: '🇸🇦', native: 'العربية' },
  { code: 'hi', name: 'Hindi', flag: '🇮🇳', native: 'हिन्दी' },
  
  // European Languages
  { code: 'nl', name: 'Dutch', flag: '🇳🇱', native: 'Nederlands' },
  { code: 'pl', name: 'Polish', flag: '🇵🇱', native: 'Polski' },
  { code: 'uk', name: 'Ukrainian', flag: '🇺🇦', native: 'Українська' },
  { code: 'cs', name: 'Czech', flag: '🇨🇿', native: 'Čeština' },
  { code: 'sk', name: 'Slovak', flag: '🇸🇰', native: 'Slovenčina' },
  { code: 'bg', name: 'Bulgarian', flag: '🇧🇬', native: 'Български' },
  { code: 'hr', name: 'Croatian', flag: '🇭🇷', native: 'Hrvatski' },
  { code: 'sr', name: 'Serbian', flag: '🇷🇸', native: 'Српски' },
  { code: 'sl', name: 'Slovenian', flag: '🇸🇮', native: 'Slovenščina' },
  { code: 'hu', name: 'Hungarian', flag: '🇭🇺', native: 'Magyar' },
  { code: 'ro', name: 'Romanian', flag: '🇷🇴', native: 'Română' },
  { code: 'el', name: 'Greek', flag: '🇬🇷', native: 'Ελληνικά' },
  { code: 'tr', name: 'Turkish', flag: '🇹🇷', native: 'Türkçe' },
  { code: 'sq', name: 'Albanian', flag: '🇦🇱', native: 'Shqip' },
  { code: 'mk', name: 'Macedonian', flag: '🇲🇰', native: 'Македонски' },
  { code: 'bs', name: 'Bosnian', flag: '🇧🇦', native: 'Bosanski' },
  
  // Nordic Languages
  { code: 'sv', name: 'Swedish', flag: '🇸🇪', native: 'Svenska' },
  { code: 'no', name: 'Norwegian', flag: '🇳🇴', native: 'Norsk' },
  { code: 'da', name: 'Danish', flag: '🇩🇰', native: 'Dansk' },
  { code: 'fi', name: 'Finnish', flag: '🇫🇮', native: 'Suomi' },
  { code: 'is', name: 'Icelandic', flag: '🇮🇸', native: 'Íslenska' },
  
  // Baltic Languages
  { code: 'et', name: 'Estonian', flag: '🇪🇪', native: 'Eesti' },
  { code: 'lv', name: 'Latvian', flag: '🇱🇻', native: 'Latviešu' },
  { code: 'lt', name: 'Lithuanian', flag: '🇱🇹', native: 'Lietuvių' },
  
  // Celtic Languages
  { code: 'ga', name: 'Irish', flag: '🇮🇪', native: 'Gaeilge' },
  { code: 'cy', name: 'Welsh', flag: '🏴', native: 'Cymraeg' },
  { code: 'gd', name: 'Scottish Gaelic', flag: '🏴', native: 'Gàidhlig' },
  
  // Romance Languages
  { code: 'ca', name: 'Catalan', flag: '🇪🇸', native: 'Català' },
  { code: 'gl', name: 'Galician', flag: '🇪🇸', native: 'Galego' },
  { code: 'eu', name: 'Basque', flag: '🇪🇸', native: 'Euskara' },
  { code: 'co', name: 'Corsican', flag: '🇫🇷', native: 'Corsu' },
  { code: 'mt', name: 'Maltese', flag: '🇲🇹', native: 'Malti' },
  { code: 'lb', name: 'Luxembourgish', flag: '🇱🇺', native: 'Lëtzebuergesch' },
  
  // Middle Eastern & Central Asian
  { code: 'he', name: 'Hebrew', flag: '🇮🇱', native: 'עברית' },
  { code: 'fa', name: 'Persian/Farsi', flag: '🇮🇷', native: 'فارسی' },
  { code: 'ur', name: 'Urdu', flag: '🇵🇰', native: 'اردو' },
  { code: 'ps', name: 'Pashto', flag: '🇦🇫', native: 'پښتو' },
  { code: 'ku', name: 'Kurdish', flag: '🏳️', native: 'کوردی' },
  { code: 'az', name: 'Azerbaijani', flag: '🇦🇿', native: 'Azərbaycan' },
  { code: 'ka', name: 'Georgian', flag: '🇬🇪', native: 'ქართული' },
  { code: 'hy', name: 'Armenian', flag: '🇦🇲', native: 'Հայերեն' },
  { code: 'kk', name: 'Kazakh', flag: '🇰🇿', native: 'Қазақша' },
  { code: 'ky', name: 'Kyrgyz', flag: '🇰🇬', native: 'Кыргызча' },
  { code: 'tg', name: 'Tajik', flag: '🇹🇯', native: 'Тоҷикӣ' },
  { code: 'tk', name: 'Turkmen', flag: '🇹🇲', native: 'Türkmençe' },
  { code: 'uz', name: 'Uzbek', flag: '🇺🇿', native: 'Oʻzbekcha' },
  { code: 'ug', name: 'Uyghur', flag: '🇨🇳', native: 'ئۇيغۇرچە' },
  { code: 'mn', name: 'Mongolian', flag: '🇲🇳', native: 'Монгол' },
  
  // South Asian Languages
  { code: 'bn', name: 'Bengali', flag: '🇧🇩', native: 'বাংলা' },
  { code: 'pa', name: 'Punjabi', flag: '🇮🇳', native: 'ਪੰਜਾਬੀ' },
  { code: 'gu', name: 'Gujarati', flag: '🇮🇳', native: 'ગુજરાતી' },
  { code: 'mr', name: 'Marathi', flag: '🇮🇳', native: 'मराठी' },
  { code: 'ta', name: 'Tamil', flag: '🇮🇳', native: 'தமிழ்' },
  { code: 'te', name: 'Telugu', flag: '🇮🇳', native: 'తెలుగు' },
  { code: 'kn', name: 'Kannada', flag: '🇮🇳', native: 'ಕನ್ನಡ' },
  { code: 'ml', name: 'Malayalam', flag: '🇮🇳', native: 'മലയാളം' },
  { code: 'or', name: 'Odia', flag: '🇮🇳', native: 'ଓଡ଼ିଆ' },
  { code: 'si', name: 'Sinhala', flag: '🇱🇰', native: 'සිංහල' },
  { code: 'ne', name: 'Nepali', flag: '🇳🇵', native: 'नेपाली' },
  
  // Southeast Asian Languages
  { code: 'th', name: 'Thai', flag: '🇹🇭', native: 'ไทย' },
  { code: 'vi', name: 'Vietnamese', flag: '🇻🇳', native: 'Tiếng Việt' },
  { code: 'id', name: 'Indonesian', flag: '🇮🇩', native: 'Bahasa Indonesia' },
  { code: 'ms', name: 'Malay', flag: '🇲🇾', native: 'Bahasa Melayu' },
  { code: 'tl', name: 'Tagalog/Filipino', flag: '🇵🇭', native: 'Tagalog' },
  { code: 'ceb', name: 'Cebuano', flag: '🇵🇭', native: 'Cebuano' },
  { code: 'jv', name: 'Javanese', flag: '🇮🇩', native: 'Basa Jawa' },
  { code: 'su', name: 'Sundanese', flag: '🇮🇩', native: 'Basa Sunda' },
  { code: 'my', name: 'Burmese', flag: '🇲🇲', native: 'မြန်မာဘာသာ' },
  { code: 'km', name: 'Khmer', flag: '🇰🇭', native: 'ភាសាខ្មែរ' },
  { code: 'lo', name: 'Lao', flag: '🇱🇦', native: 'ພາສາລາວ' },
  
  // African Languages
  { code: 'sw', name: 'Swahili', flag: '🇹🇿', native: 'Kiswahili' },
  { code: 'am', name: 'Amharic', flag: '🇪🇹', native: 'አማርኛ' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬', native: 'Hausa' },
  { code: 'yo', name: 'Yoruba', flag: '🇳🇬', native: 'Yorùbá' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬', native: 'Igbo' },
  { code: 'zu', name: 'Zulu', flag: '🇿🇦', native: 'isiZulu' },
  { code: 'xh', name: 'Xhosa', flag: '🇿🇦', native: 'isiXhosa' },
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦', native: 'Afrikaans' },
  { code: 'st', name: 'Sesotho', flag: '🇱🇸', native: 'Sesotho' },
  { code: 'rw', name: 'Kinyarwanda', flag: '🇷🇼', native: 'Ikinyarwanda' },
  { code: 'sn', name: 'Shona', flag: '🇿🇼', native: 'chiShona' },
  { code: 'so', name: 'Somali', flag: '🇸🇴', native: 'Soomaali' },
  { code: 'ti', name: 'Tigrinya', flag: '🇪🇷', native: 'ትግርኛ' },
  { code: 'om', name: 'Oromo', flag: '🇪🇹', native: 'Oromoo' },
  { code: 'lg', name: 'Luganda', flag: '🇺🇬', native: 'Luganda' },
  { code: 'ak', name: 'Akan/Twi', flag: '🇬🇭', native: 'Twi' },
  { code: 'mg', name: 'Malagasy', flag: '🇲🇬', native: 'Malagasy' },
  
  // Pacific Languages
  { code: 'haw', name: 'Hawaiian', flag: '🇺🇸', native: 'ʻŌlelo Hawaiʻi' },
  { code: 'mi', name: 'Māori', flag: '🇳🇿', native: 'Te Reo Māori' },
  { code: 'sm', name: 'Samoan', flag: '🇼🇸', native: 'Gagana Samoa' },
  { code: 'to', name: 'Tongan', flag: '🇹🇴', native: 'Lea faka-Tonga' },
  { code: 'fj', name: 'Fijian', flag: '🇫🇯', native: 'Vosa Vakaviti' },
  
  // Constructed & Other Languages
  { code: 'eo', name: 'Esperanto', flag: '🌍', native: 'Esperanto' },
  { code: 'ia', name: 'Interlingua', flag: '🌍', native: 'Interlingua' },
  { code: 'la', name: 'Latin', flag: '🏛️', native: 'Latina' },
  { code: 'yi', name: 'Yiddish', flag: '🕍', native: 'ייִדיש' },
  { code: 'sa', name: 'Sanskrit', flag: '🕉️', native: 'संस्कृतम्' },
  
  // Additional Languages
  { code: 'be', name: 'Belarusian', flag: '🇧🇾', native: 'Беларуская' },
  { code: 'fy', name: 'Frisian', flag: '🇳🇱', native: 'Frysk' },
  { code: 'ba', name: 'Bashkir', flag: '🇷🇺', native: 'Башҡортса' },
  { code: 'tt', name: 'Tatar', flag: '🇷🇺', native: 'Татарча' },
  { code: 'cv', name: 'Chuvash', flag: '🇷🇺', native: 'Чӑвашла' },
  { code: 'kv', name: 'Komi', flag: '🇷🇺', native: 'Коми' },
  { code: 'udm', name: 'Udmurt', flag: '🇷🇺', native: 'Удмурт' },
  { code: 'mhr', name: 'Mari', flag: '🇷🇺', native: 'Марий' },
  { code: 'sah', name: 'Sakha/Yakut', flag: '🇷🇺', native: 'Саха' },
  { code: 'tyv', name: 'Tuvan', flag: '🇷🇺', native: 'Тыва' }
];

// Helper function to get language by code
export const getTranslationLanguageByCode = (code: string): TranslationLanguage | undefined => {
  return TRANSLATION_LANGUAGES.find(lang => lang.code === code);
};

// Helper function for fuzzy search
export const searchTranslationLanguages = (query: string): TranslationLanguage[] => {
  if (!query.trim()) return TRANSLATION_LANGUAGES;
  
  const queryLower = query.toLowerCase();
  const words = queryLower.split(/\s+/);
  
  return TRANSLATION_LANGUAGES.filter((language) => {
    const searchableText = 
      `${language.name} ${language.native} ${language.code}`.toLowerCase();
    
    // Check if all words are found somewhere in the text
    return words.every((word) => searchableText.includes(word));
  }).sort((a, b) => {
    // Prioritize exact matches
    const aNameLower = a.name.toLowerCase();
    const bNameLower = b.name.toLowerCase();
    
    if (aNameLower === queryLower) return -1;
    if (bNameLower === queryLower) return 1;
    
    if (aNameLower.startsWith(queryLower)) return -1;
    if (bNameLower.startsWith(queryLower)) return 1;
    
    return 0;
  });
};